import { ConfigService } from '@piwikpro/platform/Platform/ConfigService';
import { useService } from '@piwikpro/platform/Platform/useService';
import Preference from '../Preference';

export function useScopedPreference(preferenceId: string, scope: string) {
  const userPreferences = useService('userPreferences');
  const config = useService<ConfigService>('config');
  const defaultLimit = config.get<number>('PAGINATION_ITEMS_PER_PAGE');

  const get = (name: string): unknown => {
    const preference = new Preference(preferenceId, userPreferences.load(), scope);

    return preference.getFromScope(name);
  };

  const set = (name: string, value: unknown): void => {
    const preference = new Preference(preferenceId, userPreferences.load(), scope);

    preference.addIntoScope(name, value);
    userPreferences.persist(preference);
  };

  const readStoredPage = (): number => {
    const page = get('page');

    return typeof page === 'number' && page > 0 ? page : 1;
  };

  const readStoredLimit = (): number => {
    const limit = get('limit');

    return typeof limit === 'number' && limit > 0 ? limit : defaultLimit;
  };

  return {
    get, set, readStoredPage, readStoredLimit,
  };
}
